import PreLoader from "components/PreLoader/PreLoader";
import styled from "styled-components";

export const Spinner = styled(PreLoader)`
  position: absolute;
  width: 20px;
  height: 14px;
  transform-origin: 0 10px;
  transform: scale(0.5);
`;

export const StyledForm = styled.form``;

